import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function PricingSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const {
    trackAddToCart
  } = useMetaPixel();
  const handleCTAClick = () => {
    trackAddToCart();
  };
  return <section id="pricing" ref={ref} className="py-24 px-4" data-id="element-106">
      <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 50
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-107">
        {/* Price */}
        <div className="text-center mb-16" data-id="element-108">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-109">
            Lo que cuesta{' '}
            <span className="text-cyan-400" data-id="element-110">(y lo que te ahorra)</span>
          </h2>

          <div className="mb-6" data-id="element-111">
            <div className="text-4xl md:text-5xl font-bold text-gray-500 line-through mb-2" data-id="element-112">
              $27
            </div>
            <div className="text-6xl md:text-7xl font-bold text-cyan-400 mb-4" data-id="element-113">
              $6.39
            </div>
          </div>

          <CTAButton href="https://www.impulsodigitalexpres.com/cart/49940485964022:1" onClick={handleCTAClick} className="text-xl px-12 py-5 mb-8" data-id="element-114">
            Consigue "Avatar Digital Rentable" hoy
          </CTAButton>

          <p className="text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-115">
            No por "información". Por tiempo y por fricción eliminada.
          </p>
          <p className="text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto mt-4" data-id="element-116">
            Porque si estás desperate, tu recurso más caro no es el dinero.{' '}
            <span className="text-white font-semibold" data-id="element-117">
              Es el desgaste mental de empezar… y abandonar… y empezar… y
              abandonar.
            </span>
          </p>
        </div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="bg-zinc-900/50 border border-cyan-500/20 rounded-lg p-8 mb-12" data-id="element-118">
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-119">
            Garantía <span className="text-cyan-400" data-id="element-120">(simple, sin drama)</span>
          </h3>
          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-121">
            Si aplicas el plan 7 días y aún así no terminas con: un avatar
            definido, 10 guiones listos, y escenas repetibles, entonces el
            problema no era el avatar.{' '}
            <span className="text-white font-semibold" data-id="element-122">
              Era que estabas intentando hacerlo sin sistema.
            </span>
          </p>
        </motion.div>

        {/* Final message */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        delay: 0.5,
        duration: 0.5
      }} className="text-center" data-id="element-123">
          <p className="text-xl text-gray-300 leading-relaxed mb-8" data-id="element-124">
            Si quieres dejar de probar herramientas y empezar a publicar con
            consistencia:
          </p>

          <p className="text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-125">
            En 7 días vas a tener algo que por fin se siente sostenido:{' '}
            <span className="text-cyan-400 font-semibold" data-id="element-126">
              un personaje publicable que no depende de tu cara… ni de tu
              energía.
            </span>
          </p>
        </motion.div>
      </motion.div>
    </section>;
}